export const options = (t) => [
    { label: t('commerce.detail.intent.commercial'), value: 0 },
    { label: t('commerce.detail.intent.informational'), value: 1 },
    { label: t('commerce.detail.intent.navigational'), value: 2 },
    { label: t('commerce.detail.intent.transactional'), value: 3 },
];
